module.exports = __webpack_public_path__ + "static/petiole-mobile-075eff092ca24d1835e2699b7e112e84.svg";